'use strict';

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Plugin = require('./plugin');

module.exports = function (_Plugin) {
  _inherits(Follow, _Plugin);
  /**
   * @private
   * @param {Viewport} parent
   * @param {PIXI.DisplayObject} target to follow (object must include {x: x-coordinate, y: y-coordinate})
   * @param {object} [options]
   * @param {number} [options.speed=0] to follow in pixels/frame (0=teleport to location)
   * @param {number} [options.radius] radius (in world coordinates) of center circle where movement is allowed without moving the viewport
   */


  function Follow(parent, target, options) {
    _classCallCheck(this, Follow);

    var _this = _possibleConstructorReturn(this, (Follow.__proto__ || Object.getPrototypeOf(Follow)).call(this, parent));

    options = options || {};
    _this.speed = options.speed || 0;
    _this.target = target;
    _this.radius = options.radius;
    return _this;
  }

  _createClass(Follow, [{
    key: 'update',
    value: function update() {
      if (this.paused) {
        return;
      }

      var center = this.parent.center;
      var toX = this.target.x,
          toY = this.target.y;

      if (this.radius) {
        var distance = Math.sqrt(Math.pow(this.target.y - center.y, 2) + Math.pow(this.target.x - center.x, 2));

        if (distance > this.radius) {
          var angle = Math.atan2(this.target.y - center.y, this.target.x - center.x);
          toX = this.target.x - Math.cos(angle) * this.radius;
          toY = this.target.y - Math.sin(angle) * this.radius;
        } else {
          return;
        }
      }

      var deltaX = toX - center.x;
      var deltaY = toY - center.y;

      if (deltaX || deltaY) {
        if (this.speed) {
          var _angle = Math.atan2(toY - center.y, toX - center.x);

          var changeX = Math.cos(_angle) * this.speed;
          var changeY = Math.sin(_angle) * this.speed;
          var x = Math.abs(changeX) > Math.abs(deltaX) ? toX : center.x + changeX;
          var y = Math.abs(changeY) > Math.abs(deltaY) ? toY : center.y + changeY;
          this.parent.moveCenter(x, y);
          this.parent.emit('moved', {
            viewport: this.parent,
            type: 'follow'
          });
        } else {
          this.parent.moveCenter(toX, toY);
          this.parent.emit('moved', {
            viewport: this.parent,
            type: 'follow'
          });
        }
      }
    }
  }]);

  return Follow;
}(Plugin);